// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"428fba3a","168":"21f06b3d","702":"b83d9778","914":"bac09cf0","977":"b5dc935d"}[chunkId] + ".chunk.js";
};